(function camdekoStudioPilot(){
  'use strict';
  const mount=document.getElementById('camdeko-studio-root');
  if(!mount) return;
  const studioRoot=mount;
  if(!studioRoot.querySelector('#previewArea')) { console.warn('CAMDEKO Studio: tasarım alanı bulunamadı'); return; }
(function(){
    'use strict';
    // CAMDEKO Studio: kişiye özel Shopify varyant fiyatları ve orijinal dosya yüklemesi canlı ürün verilerinden eşleştirilir.
    const prices = data => data.map(v=>({w:v[0],h:v[1],price:v[2]}));
    const sets=(p1,p2,p3)=>[
      {w:920,h:320,price:p1,label:'Medium · 50×70 / Ø60 / 50×70'},
      {w:920,h:320,price:p2,label:'Large · 60×90 / Ø80 / 60×90'},
      {w:920,h:320,price:p3,label:'X Large · 70×110 / Ø80 / 70×110'}
    ];
    const shapes=[
      {id:'dikey',label:'Dikey',fullName:'Kişiye Özel Dikey Cam Tablo',kind:'rect',group:'classic',productType:'table',url:'/products/kisiye-ozel-baski-tasarim-kisilestirilebilir-gercek-dikey-kirilmaz-cam-tablo',sizes:prices([[25,35,1499],[35,50,2489],[50,70,3299],[60,90,3999],[70,110,4499],[90,140,7999]])},
      {id:'yatay',label:'Yatay',fullName:'Kişiye Özel Yatay Cam Tablo',kind:'rect',group:'classic',productType:'table',url:'/products/kisiye-ozel-tasarim-gercek-kirilmaz-yatay-cam-tablo',sizes:prices([[35,25,1499],[50,35,2489],[70,50,3299],[90,60,3999],[110,70,4499],[140,90,7999]])},
      {id:'kare',label:'Kare',fullName:'Kişiye Özel Kare Cam Tablo',kind:'rect',group:'classic',productType:'table',url:'/products/kisiye-ozel-baski-tasarim-kare-cam-tablo',sizes:prices([[40,40,2199],[50,50,2699],[60,60,3499],[80,80,4499],[100,100,5999]])},
      {id:'yuvarlak',label:'Yuvarlak',fullName:'Kişiye Özel Yuvarlak Cam Tablo',kind:'circle',group:'classic',productType:'table',url:'/products/kisiye-tasarim-ozel-baski-kirilmaz-temperli-oval-yuvarlak-cam-tablo',sizes:[...prices([[30,30,1499],[40,40,2199],[50,50,2699],[60,60,3499],[80,80,4499],[100,100,5999],[120,120,7999]]),{w:30,h:30,price:1899,label:'30*30 Cam Tablo + Ayaklık',variantId:'55784842428707'}]},
      {id:'oval-dikey',label:'Oval Dikey',fullName:'Kişiye Özel Oval Dikey Cam Tablo',kind:'oval',group:'classic',productType:'table',url:'/products/kisiye-ozel-oval-dikey-cam-tablo',sizes:prices([[50,70,3199],[60,90,3999],[70,110,4499],[90,140,7899]])},
      {id:'oval-yatay',label:'Oval Yatay',fullName:'Kişiye Özel Oval Yatay Cam Tablo',kind:'oval',group:'classic',productType:'table',url:'/products/kisiye-ozel-oval-yatay-cam-tablo',sizes:prices([[70,50,3199],[90,60,3999],[110,70,4499],[140,90,7899]])},
      {id:'pano-yatay',label:'Panoramik Yatay',fullName:'Kişiye Özel Yatay Panoramik Cam Tablo',kind:'rect',group:'classic',productType:'table',url:'/products/kisiye-tasarim-baski-ozel-modern-panoramik-cam-tablo',sizes:prices([[110,40,3499],[150,55,6999]])},
      {id:'pano-dikey',label:'Panoramik Dikey',fullName:'Kişiye Özel Dikey Panoramik Cam Tablo',kind:'rect',group:'classic',productType:'table',url:'/products/kisiye-ozel-baski-tasarim-modern-dikey-panoramik-cam-tablo',sizes:prices([[40,110,3499],[55,150,6999]])},
      {id:'skate-dikey',label:'Skate Board Dikey',fullName:'Kişiye Özel Skate Board Dikey Cam Tablo',kind:'skate',group:'special',productType:'table',url:'/products/kisiye-ozel-skate-board-cam-tablo-studio',sizes:prices([[20,80,2499],[25,110,3499],[30,150,6999]])},
      {id:'skate-yatay',label:'Skate Board Yatay',fullName:'Kişiye Özel Skate Board Yatay Cam Tablo',kind:'skate',group:'special',productType:'table',url:'/products/kisiye-ozel-skate-board-cam-tablo-studio',sizes:prices([[80,20,2499],[110,25,3499],[150,30,6999]])},
      {id:'surf-dikey',label:'Surf Board Dikey',fullName:'Kişiye Özel Surf Board Dikey Cam Tablo',kind:'surf',group:'special',productType:'table',url:'/products/kisiye-ozel-surf-board-cam-tablo-studio',sizes:prices([[30,110,4999],[40,150,6999]])},
      {id:'surf-yatay',label:'Surf Board Yatay',fullName:'Kişiye Özel Surf Board Yatay Cam Tablo',kind:'surf',group:'special',productType:'table',url:'/products/kisiye-ozel-surf-board-cam-tablo-studio',sizes:prices([[110,30,4999],[150,40,6999]])},
      {id:'ozel-sekilli-set',label:'Şekilli Kesim Cam Tablo',fullName:'Şekilli Kesim Cam Tablo',kind:'set',group:'special',productType:'table',url:'/products/kisiye-ozel-sekilli-kesim-kirilmaz-temperli-cam-tablo-seti',sizes:sets(8999,11999,12999)},
      {id:'yuvarlak-saat',label:'Yuvarlak Saat',fullName:'Kişiye Özel Yuvarlak Cam Duvar Saati',kind:'circle',group:'classic',productType:'clock',url:'/products/buyuk-boy-kurumsal-kisiye-ozel-cam-duvar-saati-tablo',sizes:prices([[30,30,1699],[40,40,2199],[50,50,2699],[60,60,3199],[80,80,4699]])},
      {id:'yatay-saat',label:'Yatay Saat',fullName:'Kişiye Özel Yatay Cam Duvar Saati',kind:'rect',group:'classic',productType:'clock',url:'/products/kisiye-ozel-yatay-cam-duvar-saati',sizes:prices([[110,40,3989],[150,55,7299]])},
      {id:'saatli-sekilli-set',label:'Şekilli Saat Seti',fullName:'Kişiye Özel Şekilli Kesim Cam Saat ve Tablo Seti',kind:'clockset',group:'special',productType:'clock',url:'/products/kisiye-ozel-sekilli-kesim-cam-saat-ve-tablo-seti',sizes:sets(8999,11999,13499)}
    ];
    // Gönderilen 30x110 CAMDEKO surf kesim şablonunun doğrudan izlenen konturu.
    // Kontur: sivri burun, uzun yan kavisler, altta iki kuyruk ucu ve ortada V oyuk.
    // Dikey: burun üstte. Yatay: aynı şekil 90 derece saat yönünde döner.
    const surfY=[15,24,33,42,51,60,69,78,87,96,105,114,123,132,141,150,159,168,177,186,195,204,213,222,231,240,249,258,267,276,285,294,303,312,321,330,339,348,357,366,375,384,393,402,411,420,429,438,447,456,465,474,483,492,501,510,519,528,537,546,555,564,573,582,591,600,609,618,627,629,635,638,641,644,647,650,653,656,657];
    const surfLeft=[90,81,74,68,62,57,53,49,45,42,39,36,33,31,28,26,24,22,20,19,17,16,15,14,13,12,11,10,10,9,9,8,8,8,8,8,8,8,8,8,9,9,10,10,11,12,13,14,15,16,17,18,19,21,22,23,25,26,28,30,31,33,35,37,40,42,44,46,49,50,52,52,54,55,56,57,59,61,62];
    const surfRight=[100,109,117,123,128,133,138,141,145,148,151,154,157,160,162,164,166,168,170,172,173,175,176,177,178,179,180,181,181,182,182,183,183,183,183,183,183,183,183,182,182,182,181,180,180,179,178,177,176,175,174,173,172,170,169,168,166,164,163,161,159,157,155,153,151,149,146,144,141,140,138,137,136,135,134,132,131,128,128];
    function camdekoSurfTemplate(vertical){
      const outline=[[95,14]];
      // Sol ve sağ dış çizgi, iletilen şablondan alınmıştır; hiçbir ovalleştirme yapılmaz.
      for(let i=0;i<surfY.length;i++)outline.push([surfRight[i],surfY[i]]);
      outline.push([124,657],[120,657],[116,656],[113,654],[109,650],[106,645],[103,641],[99,638],[95,636]);
      outline.push([91,638],[87,641],[84,645],[80,650],[76,654],[73,656],[69,657],[66,657]);
      for(let i=surfY.length-1;i>=0;i--)outline.push([surfLeft[i],surfY[i]]);
      const normalized=outline.map(([x,y])=>[(x-8)/175,(y-14)/643]);
      return vertical?normalized:normalized.map(([x,y])=>[1-y,x]);
    }
    const surfVerticalPts=camdekoSurfTemplate(true),surfHorizontalPts=camdekoSurfTemplate(false);
    const cssShape=pts=>'polygon('+pts.map(([x,y])=>`${(x*100).toFixed(2)}% ${(y*100).toFixed(2)}%`).join(',')+')';
    const byId=id=>studioRoot.querySelector('#'+id);
    const shapeOptions=byId('shapeOptions'),extraOptions=byId('extraShapeOptions'),sizeOptions=byId('sizeOptions'),stage=byId('previewArea'),frame=byId('glassShape'),photo=byId('clientPhoto'),demo=byId('defaultArt'),setPreview=byId('setPreview'),input=byId('photoInput');
    const singleClockOverlay=byId('singleClockOverlay');
    const productTabs=byId('productTabs');
    const photoParts=[0,1,2].map(()=>({url:null,fileName:'',naturalWidth:0,naturalHeight:0,zoom:1,panX:0,panY:0}));
    const single={url:null,fileName:'',naturalWidth:0,naturalHeight:0,zoom:1,panX:0,panY:0};
    const partBoxes=[{x:28,y:62,w:324,h:196},{x:324,y:24,w:272,h:272},{x:568,y:62,w:324,h:196}];
    const partNames=['Sol Cam','Orta Yuvarlak','Sağ Cam'];
    let currentType='table',chosen='dikey',sizeIndex=3,activePart=0,pointers=new Map(),pinchDistance=null,toastTimeout=null;
    // Kişiye özel koleksiyonundan doğrudan açılan Studio modeli.
    // Tanımsız URL değerleri dikkate alınır; mevcut genel Studio açılışı değişmez.
    const incomingModel=new URLSearchParams(window.location.search).get('model');
    const incomingShape=shapes.find(s=>s.id===incomingModel);
    if(incomingShape){
      currentType=incomingShape.productType;
      chosen=incomingShape.id;
      sizeIndex=0;
      productTabs.querySelectorAll('[data-product-type]').forEach(btn=>{
        const active=btn.dataset.productType===currentType;
        btn.classList.toggle('selected',active);
        btn.setAttribute('aria-selected',active?'true':'false');
      });
    }
    const curr=n=>n.toLocaleString('tr-TR')+' TL';
    const activeShapes=()=>shapes.filter(s=>s.productType===currentType);
    const shape=()=>shapes.find(s=>s.id===chosen);
    const size=()=>shape().sizes[sizeIndex];
    const isSet=()=>['set','clockset'].includes(shape().kind);
    const hasClock=()=>shape().productType==='clock' || shape().kind==='clockset';
    const view=()=>isSet()?photoParts[activePart]:single;
    function iconFor(s){
      if(s.kind==='set'||s.kind==='clockset')return `<svg viewBox="0 0 64 55" aria-hidden="true"><path d="M3 14 L26 14 Q19 23 19 27 Q19 34 26 41 L3 41 Z"/><circle cx="32" cy="27.5" r="20"/><path d="M38 14 L61 14 L61 41 L38 41 Q45 34 45 27 Q45 23 38 14 Z"/>${s.kind==='clockset'?'<path d="M32 27 L32 17 M32 27 L38 31" stroke-width="1.4"/>':''}</svg>`;
      if(s.kind==='skate'){const vert=s.sizes[0].w<s.sizes[0].h;return `<svg viewBox="0 0 64 55" aria-hidden="true">${vert?'<rect x="25" y="2.5" width="14" height="50" rx="7"/>':'<rect x="3" y="21" width="58" height="13" rx="6.5"/>'}</svg>`;}
      if(s.kind==='surf'){
        const vert=s.sizes[0].w<s.sizes[0].h, pts=vert?surfVerticalPts:surfHorizontalPts;
        const points=pts.map(([x,y])=>`${(vert?25+x*14:3+x*58).toFixed(1)},${(vert?2+y*51:19.5+y*16).toFixed(1)}`).join(' ');
        return `<svg viewBox="0 0 64 55" aria-hidden="true"><polygon points="${points}"/></svg>`;
      }
      const sample=s.sizes[0],r=sample.w/sample.h;
      let w=35,h=35;
      if(r<1){h=43;w=43*r;}else if(r>1){w=45;h=45/r;}
      if(r>2.2){w=48;h=16;}else if(r<.46){h=44;w=15;}
      if(s.kind==='circle'){w=31;h=31;}
      if(s.kind==='oval'){if(r<1){w=25;h=43;}else{w=44;h=26;}}
      return `<svg viewBox="0 0 64 55" aria-hidden="true"><${s.kind==='circle'||s.kind==='oval'?'ellipse':'rect'} ${s.kind==='circle'||s.kind==='oval'?`cx="32" cy="27.5" rx="${w/2}" ry="${h/2}"`:`x="${32-w/2}" y="${27.5-h/2}" width="${w}" height="${h}" rx="1.8"`}/></svg>`;
    }
    function renderButtons(){
      const btn=s=>`<button type="button" class="shape-btn ${s.id===chosen?'selected':''} ${s.label.length>17?'is-long':''}" data-shape="${s.id}" aria-pressed="${s.id===chosen}" title="${s.fullName}">${iconFor(s)}<span class="shape-label">${s.label}</span></button>`;
      const primary=activeShapes().filter(s=>s.group==='classic');
      const extra=activeShapes().filter(s=>s.group==='special');
      shapeOptions.innerHTML=primary.map(btn).join('');
      extraOptions.innerHTML=extra.map(btn).join('');
      byId('primaryShapeLabel').textContent=currentType==='table'?'KLASİK CAM FORMLARI':'CAM SAAT MODELLERİ';
      byId('primaryShapeCount').textContent=primary.length+' MODEL';
      byId('extraShapeLabel').textContent=currentType==='table'?'ÖZEL KESİM & SETLER':'ÖZEL SAAT SETLERİ';
      byId('extraShapeCount').textContent=extra.length+' MODEL';
      byId('extraShapeCategory').classList.toggle('hidden',!extra.length);
      extraOptions.hidden=!extra.length;
      let sh=shape();
      sizeOptions.innerHTML=sh.sizes.map((s,i)=>`<button type="button" class="measure-btn ${isSet()?'is-set-size':''} ${i===sizeIndex?'selected':''}" data-size="${i}" aria-pressed="${i===sizeIndex}"><span class="size-label">${s.label||`${s.w} × ${s.h} cm`}</span><span class="size-price">${s.price===null?'Fiyat alınıyor':curr(s.price)}</span></button>`).join('');
      byId('activeProductName').textContent=sh.fullName;
      byId('activeProductNote').textContent=sh.kind==='clockset'?'2 yan cam tablo + ortada yuvarlak saat · 3 ayrı görsel':sh.kind==='set'?'2 özel kesim yan cam + ortada yuvarlak cam · 3 ayrı görsel':hasClock()?'Saat olarak önizlenir; merkezde kadran ve kollar gösterilir.':'Seçtiğiniz ölçü, fotoğrafınızla kişiye özel hazırlanır.';
    }
    function updatePartUI(){
      for(let i=0;i<3;i++){
        let p=photoParts[i];
        byId('partStatus'+i).textContent=p.url?'Yüklendi · Değiştir':'Görsel yükle +';
        byId('setOutline'+i).setAttribute('stroke',i===activePart?'#b89b6d':'rgba(255,255,255,.96)');
        byId('setOutline'+i).setAttribute('stroke-width',i===activePart?'5':'3.5');
      }
      studioRoot.querySelectorAll('[data-upload-panel]').forEach(el=>el.classList.toggle('is-active',Number(el.dataset.uploadPanel)===activePart));
      byId('midPartName').textContent=shape().kind==='clockset'?'Orta Saat':'Orta Yuvarlak';
      byId('activePartLabel').textContent='Düzenlenen parça: '+(activePart===1&&shape().kind==='clockset'?'Orta Saat':partNames[activePart]);
      const count=photoParts.filter(p=>p.url).length;
      byId('qualityText').textContent=`${count}/3 görsel yüklendi. Her parça için farklı fotoğraf kullanılabilir; görsellerin orijinalleri korunur.`;
      byId('previewFlag').textContent=count?'Fotoğraflarınızla önizleme · '+count+'/3':'Üç cam için ayrı görsel yükleyin';
      byId('dragHelp').lastChild.textContent='Seçili camın fotoğrafını sürükleyin';
    }
    function updateFrame(){
      const sh=shape(),s=size(),set=isSet(),r=set?920/320:s.w/s.h;
      const maxW=Math.max(130,stage.clientWidth-(set?40:94)),maxH=Math.max(145,stage.clientHeight-(set?70:83));
      let w=Math.min(maxW,maxH*r),h=w/r;
      if(h>maxH){h=maxH;w=h*r;}
      frame.style.width=w+'px';frame.style.height=h+'px';
      frame.classList.toggle('is-set',set);frame.classList.toggle('is-surf',sh.kind==='surf');frame.classList.toggle('is-skate',sh.kind==='skate');frame.classList.toggle('is-round-clock',sh.productType==='clock' && sh.kind==='circle');
      const vertical=s.w<s.h;
      frame.style.clipPath=sh.kind==='surf'?cssShape(vertical?surfVerticalPts:surfHorizontalPts):'';
      frame.style.borderRadius=sh.kind==='circle'||sh.kind==='oval'?'50%':sh.kind==='skate'?'999px':'3px';
      frame.setAttribute('aria-label',`${sh.fullName}, ${s.label||s.w+' × '+s.h+' santimetre'} önizlemesi`);
      byId('selectedCaption').textContent=`${sh.label} · ${s.label||s.w+' × '+s.h+' cm'}`;
      byId('totalPrice').textContent=s.price===null?'Fiyat alınıyor':curr(s.price);
      byId('taxLabel').textContent='KDV dahil';
      demo.hidden=set||!!single.url;
      photo.hidden=set||!single.url;
      setPreview.hidden=!set;
      byId('clockOverlay').style.display=sh.kind==='clockset'?'':'none';
      singleClockOverlay.classList.toggle('show',hasClock()&&!set);
      byId('dropZone').hidden=set;
      byId('setUploadControls').hidden=!set;
      byId('studioPhotoHint').textContent=set?'Sol, orta ve sağ parçalar için üç ayrı fotoğraf seçin.':'Tek fotoğraf seçin; soldaki önizlemeden yerleşimini ayarlayın.';
      byId('clearActivePart').disabled=!photoParts[activePart].url;
      if(set){
        updatePartUI();
      } else {
        byId('dragHelp').lastChild.textContent='Fotoğrafı sürükleyerek konumlandırın';
        byId('previewFlag').textContent=single.url?'Fotoğrafınızla canlı önizleme':'Örnek görselle önizleme';
        byId('uploadPrimary').textContent=single.url?'Fotoğrafı değiştir: '+single.fileName:'Fotoğraf seç veya buraya sürükle';
        byId('qualityText').textContent=single.url?`Görsel: ${single.naturalWidth.toLocaleString('tr-TR')} × ${single.naturalHeight.toLocaleString('tr-TR')} piksel. Orijinal fotoğrafın kalitesi korunur.`:'Fotoğraf yüklendiğinde görüntü boyutlarını burada görebilirsiniz.';
      }
      
      updatePhotoFit();
    }
    function updatePhotoFit(){
      const w=frame.clientWidth,h=frame.clientHeight;
      if(isSet()){
        photoParts.forEach((p,i)=>{
          const el=byId('setPhoto'+i),blank=byId('setDefault'+i),b=partBoxes[i];
          blank.style.display=p.url?'none':'';el.style.display=p.url?'':'none';
          if(!p.url||!p.naturalWidth||!p.naturalHeight)return;
          const aspect=p.naturalWidth/p.naturalHeight;
          const iw=Math.max(b.w*p.zoom,b.h*p.zoom*aspect),ih=iw/aspect;
          const maxX=Math.max(0,(iw-b.w)/2),maxY=Math.max(0,(ih-b.h)/2);
          p.panX=Math.max(-maxX,Math.min(maxX,p.panX));p.panY=Math.max(-maxY,Math.min(maxY,p.panY));
          el.setAttribute('x',String(b.x+(b.w-iw)/2+p.panX));
          el.setAttribute('y',String(b.y+(b.h-ih)/2+p.panY));
          el.setAttribute('width',String(iw));el.setAttribute('height',String(ih));
          el.setAttribute('href',p.url);
        });
      }else if(single.url&&single.naturalWidth&&single.naturalHeight){
        const aspect=single.naturalWidth/single.naturalHeight;
        const iw=Math.max(w*single.zoom,h*single.zoom*aspect),ih=iw/aspect;
        const maxX=Math.max(0,(iw-w)/2),maxY=Math.max(0,(ih-h)/2);
        single.panX=Math.max(-maxX,Math.min(maxX,single.panX));single.panY=Math.max(-maxY,Math.min(maxY,single.panY));
        photo.style.width=iw+'px';photo.style.height=ih+'px';
        photo.style.left=((w-iw)/2+single.panX)+'px';photo.style.top=((h-ih)/2+single.panY)+'px';
      }else{
        demo.style.transform=`translate(${single.panX}px,${single.panY}px) scale(${single.zoom})`;
      }
      const v=view();byId('zoomSlider').value=String(v.zoom);byId('zoomPct').textContent=Math.round(v.zoom*100)+'%';
    }
    function selectShape(id){
      if(!shapes.some(s=>s.id===id)||id===chosen)return;
      const before=isSet();chosen=id;const options=shape().sizes;sizeIndex=options.length>=4?Math.min(2,options.length-1):0;
      // Tekil fotoğraf ve üçlü setteki 3 ayrı fotoğraf şekil değiştirilse de korunur.
      if(isSet()&&!before)activePart=0;
      renderButtons();updateFrame();
    }
    function selectPart(i){if(i<0||i>2)return;activePart=i;updatePartUI();byId('clearActivePart').disabled=!photoParts[i].url;updatePhotoFit();}
    function changeZoom(z){const v=view();v.zoom=Math.max(1,Math.min(3,Math.round(z*100)/100));updatePhotoFit();}
    function selectProductType(type){
      if(type===currentType) return;
      currentType=type;
      const available=activeShapes();
      if(!available.some(s=>s.id===chosen)){chosen=available[0].id; sizeIndex=Math.min(available[0].sizes.length-1, available[0].sizes.length>=4?2:0);} else {sizeIndex=Math.min(sizeIndex, shape().sizes.length-1);} 
      productTabs.querySelectorAll('[data-product-type]').forEach(btn=>{const on=btn.dataset.productType===type;btn.classList.toggle('selected',on);btn.setAttribute('aria-selected',on?'true':'false');});
      renderButtons();updateFrame();
    }
    [shapeOptions,extraOptions].forEach(g=>g.addEventListener('click',e=>{let b=e.target.closest('[data-shape]');if(b)selectShape(b.dataset.shape);}));
    productTabs.addEventListener('click',e=>{const b=e.target.closest('[data-product-type]'); if(b) selectProductType(b.dataset.productType);});
    sizeOptions.addEventListener('click',e=>{let b=e.target.closest('[data-size]');if(b){sizeIndex=Number(b.dataset.size);renderButtons();updateFrame();}});
    byId('zoomSlider').addEventListener('input',e=>changeZoom(Number(e.target.value)));
    byId('minusZoom').addEventListener('click',()=>changeZoom(view().zoom-.15));
    byId('plusZoom').addEventListener('click',()=>changeZoom(view().zoom+.15));
    byId('resetPosition').addEventListener('click',()=>{Object.assign(view(),{zoom:1,panX:0,panY:0});updatePhotoFit();});
    frame.addEventListener('wheel',e=>{e.preventDefault();changeZoom(view().zoom+(e.deltaY<0?.10:-.10));},{passive:false});
    const dist=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
    frame.addEventListener('pointerdown',e=>{
      if(e.button!==undefined&&e.button!==0&&e.pointerType==='mouse')return;
      if(isSet()){
        const panel=e.target.closest?.('[data-set-panel]');
        if(!panel)return;
        selectPart(Number(panel.dataset.setPanel));
      }
      frame.setPointerCapture(e.pointerId);pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(pointers.size===2){const ps=[...pointers.values()];pinchDistance=dist(ps[0],ps[1]);}
    });
    frame.addEventListener('pointermove',e=>{
      if(!pointers.has(e.pointerId))return;
      const prev=pointers.get(e.pointerId);pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(pointers.size===1){
        const v=view(),factorX=isSet()?920/Math.max(1,frame.clientWidth):1,factorY=isSet()?320/Math.max(1,frame.clientHeight):1;
        v.panX+=(e.clientX-prev.x)*factorX;v.panY+=(e.clientY-prev.y)*factorY;updatePhotoFit();
      }else if(pointers.size===2){const ps=[...pointers.values()],d=dist(ps[0],ps[1]);if(pinchDistance&&d>0)changeZoom(view().zoom*d/pinchDistance);pinchDistance=d;}
    });
    function pointerEnd(e){pointers.delete(e.pointerId);if(pointers.size<2)pinchDistance=null;}
    ['pointerup','pointercancel','lostpointercapture'].forEach(t=>frame.addEventListener(t,pointerEnd));
    frame.addEventListener('keydown',e=>{
      let v=view(),factor=isSet()?6:10;
      if(e.key==='ArrowLeft')v.panX-=factor;
      else if(e.key==='ArrowRight')v.panX+=factor;
      else if(e.key==='ArrowUp')v.panY-=factor;
      else if(e.key==='ArrowDown')v.panY+=factor;
      else if(e.key==='+')changeZoom(v.zoom+.10);
      else if(e.key==='-')changeZoom(v.zoom-.10);
      else return;
      e.preventDefault();updatePhotoFit();
    });
    function toast(msg){let el=byId('toast');el.textContent=msg;el.hidden=false;clearTimeout(toastTimeout);toastTimeout=setTimeout(()=>el.hidden=true,3600);}
    function loadPhoto(file,part){
      if(!file)return;
      if(!['image/jpeg','image/png','image/webp'].includes(file.type)){toast('JPG, PNG veya WEBP fotoğraf seçin.');return;}
      if(file.size>50*1024*1024){toast('Bu dosya 50 MB sınırını aşıyor.');return;}
      const url=URL.createObjectURL(file),temp=new Image();
      temp.onload=()=>{
        const v=part===null?single:photoParts[part];
        if(v.url)URL.revokeObjectURL(v.url);
        Object.assign(v,{url,file,fileName:file.name,naturalWidth:temp.naturalWidth,naturalHeight:temp.naturalHeight,zoom:1,panX:0,panY:0});
        if(part===null){photo.src=url;}else{activePart=part;}
        updateFrame();
      };
      temp.onerror=()=>{URL.revokeObjectURL(url);toast('Fotoğraf tarayıcıda açılamadı; başka bir görsel deneyin.');};
      temp.src=url;
    }
    photo.addEventListener('load',updatePhotoFit);
    const zone=byId('dropZone');
    zone.addEventListener('click',()=>input.click());
    zone.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();input.click();}});
    input.addEventListener('change',e=>{loadPhoto(e.target.files?.[0],null);input.value='';});
    ['dragenter','dragover'].forEach(ev=>zone.addEventListener(ev,e=>{e.preventDefault();zone.classList.add('dragover');}));
    ['dragleave','drop'].forEach(ev=>zone.addEventListener(ev,e=>{e.preventDefault();zone.classList.remove('dragover');}));
    zone.addEventListener('drop',e=>loadPhoto(e.dataTransfer.files?.[0],null));
    studioRoot.querySelectorAll('[data-upload-panel]').forEach(b=>b.addEventListener('click',()=>{const i=Number(b.dataset.uploadPanel);selectPart(i);byId('partInput'+i).click();}));
    for(let i=0;i<3;i++)byId('partInput'+i).addEventListener('change',e=>{loadPhoto(e.target.files?.[0],i);e.target.value='';});
    byId('clearActivePart').addEventListener('click',()=>{
      const p=photoParts[activePart];if(p.url)URL.revokeObjectURL(p.url);
      photoParts[activePart]={url:null,fileName:'',naturalWidth:0,naturalHeight:0,zoom:1,panX:0,panY:0};updateFrame();
    });
    byId('continueButton').addEventListener('click',()=>{
      const sh=shape(),sz=size(),photos=isSet()?photoParts.filter(p=>p.url).length+'/3 parça':single.url?'1 fotoğraf yüklendi':'Henüz yüklenmedi';
      byId('summary').innerHTML=`<div><span>Kategori</span><b>${sh.productType==='table'?'Tablo':'Saat'}</b></div><div><span>Cam şekli</span><b>${sh.fullName}</b></div><div><span>Ölçü</span><b>${sz.label||sz.w+' × '+sz.h+' cm'}</b></div><div><span>Ürün fiyatı</span><b>${curr(sz.price)}</b></div><div><span>Görsel</span><b>${photos}</b></div><div><span>Seçili yakınlaştırma</span><b>%${Math.round(view().zoom*100)}</b></div>`;
      byId('modalBackdrop').hidden=false;
    });
    byId('closeModal').addEventListener('click',()=>byId('modalBackdrop').hidden=true);
    byId('modalBackdrop').addEventListener('click',e=>{if(e.target===byId('modalBackdrop'))byId('modalBackdrop').hidden=true;});
    document.addEventListener('keydown',e=>{if(e.key==='Escape')byId('modalBackdrop').hidden=true;});

    // CAMDEKO STUDIO FOTOĞRAF VE SHOPIFY SEPET ENTEGRASYONU
    // File uploads must resolve to persistent Upload-Lift URLs before a real Shopify cart call is allowed.
    const studioOrderForm=document.getElementById('camdeko-studio-upload-form');
    const studioProductJSON=document.getElementById('ProductJson-product-camdeko-studio');
    const studioVariantInput=document.getElementById('camdeko-studio-variant-id');
    let studioUploadField=null,studioVariant=null,studioRequestIndex=0,studioBusy=false;
    const studioProductCache=new Map();
    // Unlisted özel baskı ürünlerini Shopify Liquid'den yükle: fiyatlar ve varyantlar günceldir.
    const specialProductData=document.getElementById('camdeko-studio-special-products');
    if(specialProductData){
      try{
        const products=JSON.parse(specialProductData.textContent);
        for(const key of ['skate','surf']){
          const p=products[key];
          if(p&&p.handle&&Array.isArray(p.variants)&&p.variants.length)
            studioProductCache.set(p.handle,p);
        }
      }catch(err){console.warn('CAMDEKO özel baskı varyant verisi okunamadı',err);}
    }
    const studioVariantStatus=document.createElement('div');
    studioVariantStatus.id='studioVariantStatus';
    studioVariantStatus.style.cssText='font-size:11px;color:#666d66;line-height:1.65;margin:7px 0 15px;padding:12px;background:#f7f6f3;border-radius:10px';
    byId('continueButton').insertAdjacentElement('beforebegin',studioVariantStatus);
    const studioCartButton=document.createElement('button');
    studioCartButton.type='button';
    studioCartButton.id='studioCartButton';
    studioCartButton.className='primary-button';
    studioCartButton.textContent='Shopify Sepetine Ekle';
    studioCartButton.disabled=true;
    studioCartButton.style.marginTop='12px';
    studioCartButton.style.opacity='.55';
    const studioCartMessage=document.createElement('p');
    studioCartMessage.id='studioCartMessage';
    studioCartMessage.style.cssText='font-size:12px;line-height:1.6;margin:12px 0 0;color:#7b7367';
    byId('closeModal').insertAdjacentElement('beforebegin',studioCartMessage);
    studioCartMessage.insertAdjacentElement('afterend',studioCartButton);
    function studioGetSelectedFiles(){
      return isSet()?photoParts.map((p,i)=>({file:p.file,label:['Sol Cam','Orta Cam','Sağ Cam'][i],view:p})):
          [{file:single.file,label:'Orijinal Fotoğraf',view:single}];
    }
    function studioStatusText(){
      const sh=shape();
      if(!studioVariant)return 'Shopify ürün ve ölçü varyantı doğrulanıyor.';
      if(studioGetSelectedFiles().some(p=>!(p.file instanceof File)))return isSet()?'Sepete eklemek için sol, orta ve sağ fotoğrafları yükleyin.':'Sepete eklemek için bir fotoğraf yükleyin.';
      if(!studioUploadField||typeof studioUploadField.uploadFile!=='function'){
        if(!window.Cloudlift?.upload?.App)
          return 'Fotoğraf yükleme hizmeti şu anda hazır değil. Sayfayı yenileyin veya CAMDEKO ile iletişime geçin.';
        if(studioUploadInitFinished)
          return 'Fotoğraf yükleme hizmetine bağlanılamadı. Lütfen sayfayı yenileyin veya CAMDEKO ile iletişime geçin.';
        return 'Upload-Lift fotoğraf yükleme bağlantısı başlatılıyor…';
      }
      if(studioBusy)return 'Orijinal fotoğraflar yükleniyor ve Shopify sepetine kaydediliyor.';
      return 'Ürün ve ölçü eşleşti. Fotoğraflar orijinal dosya olarak Upload-Lift üzerinden aktarılacak.';
    }
    function studioRefreshCartAvailability(){
      const ready=!!studioVariant && !studioBusy &&
        studioGetSelectedFiles().every(x=>x.file instanceof File) &&
        !!studioUploadField && typeof studioUploadField.uploadFile==='function';
      studioCartButton.disabled=!ready;
      studioCartButton.style.opacity=ready?'1':'.55';
      studioVariantStatus.textContent=studioStatusText();
      studioCartMessage.textContent=studioStatusText();
    }
    function studioVariantFor(product, sh, sz){
      const vars=product.variants||[];
      if(sz.variantId)return vars.find(v=>String(v.id)===String(sz.variantId)&&v.available!==false);
      if(sh.kind==='set'||sh.kind==='clockset'){
        const name=String(sz.label||'').split('·')[0].trim().toLowerCase().replace(/\s+/g,'');
        return vars.find(v=>String(v.title||'').toLowerCase().replace(/\s+/g,'').startsWith(name)&&v.available!==false);
      }
      if(sh.kind==='skate'||sh.kind==='surf'){
        // Yatay ve dikey varyantları ayrı tutulur; 20x80 ve 80x20 karışmaz.
        return vars.find(v=>{
          const m=String(v.title||'').match(/(\\d+)\\s*[×*x]\\s*(\\d+)/i);
          return m && Number(m[1])===Number(sz.w) && Number(m[2])===Number(sz.h) && v.available!==false;
        });
      }
      const target=[Number(sz.w),Number(sz.h)].sort((a,b)=>a-b);
      return vars.find(v=>{
        const m=String(v.title||'').match(/(\d+)\s*[×*x]\s*(\d+)/i);
        if(!m)return false;
        const dims=[Number(m[1]),Number(m[2])].sort((a,b)=>a-b);
        return dims[0]===target[0]&&dims[1]===target[1]&&v.available!==false;
      });
    }
    async function studioSyncSelectedProduct(){
      const serial=++studioRequestIndex;
      const sh=shape(),currentSizeIndex=sizeIndex,handle=sh.url.split('/').pop();
      studioVariant=null;
      studioRefreshCartAvailability();
      try{
        let product=studioProductCache.get(handle);
        if(!product){
          const storeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
          const response=await fetch(storeRoot+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});
          if(!response.ok)throw new Error('Ürün verisi alınamadı ('+response.status+').');
          product=await response.json();
          studioProductCache.set(handle,product);
        }
        if(serial!==studioRequestIndex||chosen!==sh.id||sizeIndex!==currentSizeIndex)return;
        const match=studioVariantFor(product,sh,size());
        if(!match)throw new Error('Seçili ölçü için eşleşen Shopify varyantı bulunamadı.');
        studioVariant={id:Number(match.id),handle:handle,price:Number(match.price)/100,productId:Number(product.id)};
        size().price=studioVariant.price;
        if(studioVariantInput)studioVariantInput.value=String(studioVariant.id);
        // Studio yükleme widget'ı tek bir nötr ürün bağlamında sabit kalır.
        // Müşterinin seçtiği gerçek ürün/varyant yalnızca Shopify sepet isteğinde kullanılır.
        // Bu sayede normal kişiye özel ürünlerdeki eski Upload-Lift düzenleyicisi tetiklenmez.
        renderButtons();updateFrame();studioRefreshCartAvailability();
      }catch(err){
        if(serial!==studioRequestIndex)return;
        studioVariant=null;
        studioRefreshCartAvailability();
        studioVariantStatus.textContent='Shopify eşleştirmesi yapılamadı: '+String(err&&err.message||err);
      }
    }
    // Cloudlift: Upload-Lift bazen upload:ready olayını Studio script'inden önce gönderir.
    // Event listener kurulduktan sonra yükleyiciyi Studio sayfasında güvenle başlat.
    let studioUploadSetupCount=0,studioUploadLastError='',studioUploadInitFinished=false;
    window.addEventListener('upload:ready',function(evt){
      if(!studioOrderForm||!evt.detail||typeof evt.detail.uploadFile!=='function')return;
      studioUploadField=evt.detail;
      studioUploadInitFinished=true;
      studioRefreshCartAvailability();
    });
    function studioTryUploadSetup(){
      if(studioUploadField||!studioOrderForm||!document.querySelector('#camdeko-studio-upload-form .camdeko-studio-upload-lift'))return;
      const app=window.Cloudlift?.upload?.App;
      if(!app||typeof app.setup!=='function')return;
      // İki girişimle sınırlı. setup(true) eski instance'ı kapatıp ürün önbelleğini sıfırlar.
      if(studioUploadSetupCount>=2)return;
      studioUploadSetupCount++;
      try{
        app.setup(true);
        studioUploadLastError='';
      }catch(e){
        studioUploadLastError=String(e?.message||e);
        console.warn('CAMDEKO Studio: Upload-Lift başlatılamadı',e);
      }
      studioRefreshCartAvailability();
    }
    function studioBeginUploadInit(){
      // Shopify app embed ve sayfa script'i farklı sırayla yüklenebilir.
      let ticks=0;
      const check=window.setInterval(function(){
        ticks++;
        if(studioUploadField||ticks>20){window.clearInterval(check);studioUploadInitFinished=true;studioRefreshCartAvailability();return;}
        if(ticks===1||ticks===7||studioUploadSetupCount===0)studioTryUploadSetup();
        if(ticks===13)studioTryUploadSetup();
        studioRefreshCartAvailability();
      },500);
    }
    if(document.readyState==='complete')studioBeginUploadInit();
    else window.addEventListener('load',studioBeginUploadInit,{once:true});
    function studioNormalizedTransform(view,part){
      const w=part===null?Math.max(frame.clientWidth,1):partBoxes[part].w;
      const h=part===null?Math.max(frame.clientHeight,1):partBoxes[part].h;
      return 'z='+Number(view.zoom).toFixed(3)+';x='+(view.panX/w).toFixed(5)+';y='+(view.panY/h).toFixed(5);
    }
    async function studioAddToCart(){
      studioRefreshCartAvailability();
      if(studioCartButton.disabled)return;
      const oldShape=chosen,oldSize=sizeIndex,variantId=studioVariant.id,field=studioUploadField;
      studioBusy=true;studioRefreshCartAvailability();
      studioCartButton.textContent='Fotoğraflar yükleniyor…';
      try{
        const photoRefs=[];
        for(const f of studioGetSelectedFiles()){
          const result=await field.uploadFile(f.file);
          if(!result||typeof result.url!=='string'||!result.url.startsWith('https://'))
            throw new Error('Upload-Lift bu görsel için kalıcı dosya bağlantısı döndürmedi: '+f.label);
          photoRefs.push({label:f.label,url:result.url,view:f.view});
        }
        if(chosen!==oldShape||sizeIndex!==oldSize||!studioVariant||studioVariant.id!==variantId)
          throw new Error('Ürün seçimi değişti. Lütfen tasarımınızı yeniden kontrol edin.');
        const props={
          'CAMDEKO Studio Model':shape().fullName,
          'CAMDEKO Studio Ölçü':size().label||String(size().w)+'×'+String(size().h)+' cm'
        };
        // Upload-Lift'in kendi sipariş dosyası bağlantısını koru; aynı URL'yi ikinci defa gösterme.
        // Uygulama bağlantıyı form alanına eklemezse Studio'nun kalıcı URL yedeğini kullan.
        const nativeUploadUrls=[];
        if(studioOrderForm){
          const formValues=new FormData(studioOrderForm);
          for(const [name,value] of formValues.entries()){
            if(!name.startsWith('properties[')||!name.endsWith(']')||typeof value!=='string'||!value)continue;
            const key=name.slice(11,-1);
            props[key]=props[key]?props[key]+'; '+value:value;
            if(key.toLowerCase().startsWith('camdeko_studio')){
              nativeUploadUrls.push(...String(value).split(';').map(u=>u.trim()).filter(u=>u.startsWith('https://')));
            }
          }
        }
        photoRefs.forEach((item,i)=>{
          const nativeExists=nativeUploadUrls.some(u=>u===item.url||u.includes(item.url)||item.url.includes(u))
              || (nativeUploadUrls.length>=photoRefs.length && !!nativeUploadUrls[i]);
          if(!nativeExists)props['CAMDEKO '+item.label]=item.url;
          props['_CAMDEKO Kadraj '+(i+1)]=studioNormalizedTransform(item.view,isSet()?i:null);
        });
        const storeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        const response=await fetch(storeRoot+'cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity:1,properties:props}]})
        });
        if(!response.ok){
          const body=await response.json().catch(()=>({}));
          throw new Error(body.description||body.message||'Shopify sepete ekleme başarısız oldu.');
        }
        studioCartButton.textContent='Sepete eklendi';
        window.location.assign(storeRoot+'cart');
      }catch(err){
        studioBusy=false;studioRefreshCartAvailability();
        studioCartMessage.textContent='Sepete eklenmedi: '+String(err&&err.message||err);
        studioCartButton.textContent='Tekrar Dene';
      }
    }
    studioCartButton.addEventListener('click',studioAddToCart);
    byId('continueButton').addEventListener('click',studioRefreshCartAvailability);
    studioRoot.addEventListener('click',function(e){
      const target=e.target.closest&&e.target.closest('[data-shape],[data-size],[data-product-type]');
      if(target)queueMicrotask(studioSyncSelectedProduct);
    });
    queueMicrotask(studioSyncSelectedProduct);

    new ResizeObserver(updateFrame).observe(stage);
    renderButtons();updateFrame();
  })();
})();